import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DeploymentsSection } from "@/features/omnimizer/components/DeploymentsSection";
import { DeployWizardPage } from "@/features/omnimizer/components/DeployWizardPage";
import { canModifyDeployments } from "@/features/omnimizer/permissions";
import { validatePresetSearch } from "@/features/omnimizer/recipes";

const DeployModelRoute = () => {
  const { t } = useTranslation();
  const { preset, presetError, hotSwitch, cluster } = Route.useSearch();
  if (!canModifyDeployments()) return <Navigate to="/$" params={{ _splat: "predefined-models" }} replace />;
  return (
    <DeploymentsSection section="new" description={t("omnimizer.wizard.description")}>
      <DeployWizardPage presetId={preset} invalidPreset={presetError} presetHotSwitch={hotSwitch} presetClusterId={cluster} />
    </DeploymentsSection>
  );
};

export const Route = createFileRoute("/deployments/new")({
  validateSearch: (search: Record<string, unknown>) => ({
    ...validatePresetSearch(search),
    ...(typeof search.mode === "string" ? { mode: search.mode } : {}),
    ...(search.hotSwitch === true || search.hotSwitch === "true" || search.hotSwitch === "1" ? { hotSwitch: true } : {}),
    ...(typeof search.cluster === "string" && search.cluster.length <= 128 ? { cluster: search.cluster } : {}),
  }),
  component: DeployModelRoute,
});
